<template>
  <div
    :class="[
      'ss__desktop__submenu__item',
      submenu.layout ? `ss__desktop__submenu__item--${submenu.layout}` : '']"
    :style="submenu.style">
    <div class="ss__desktop__submenu__item__head">
      <img
        v-if="submenu.image"
        :src="submenu.image"
        :alt="submenu.name"
        class="ss__desktop__submenu__item__image"
      />
      <div class="ss__desktop__submenu__item__name">{{ submenu.name }}</div>
    </div>
    <div
      :class="[
        'ss__desktop__submenu__item__children',
        submenu.layout ? `ss__desktop__submenu__item__children--${submenu.layout}` : ''
      ]">
      <component
        v-for="item in submenu.children"
        :class="[
          'ss__desktop__submenu__item__item',
          `comp__${item.card}`
        ]"
        :key="item.name"
        :is="item.card"
        :item="item"
        :style="item.style">
      </component>
    </div>
  </div>
</template>

<script>
import SsDesktopMenuItem from '../SsDesktopMenuItem/index.vue'
import SsDesktopMenuPostItem from '../SsDesktopMenuPostItem/index.vue'
import SsDesktopMenuSeriesItem from '../SsDesktopMenuSeriesItem/index.vue'
import SsDesktopMenuGoodItem from '../SsDesktopMenuGoodItem/index.vue'
import SsDesktopMenuPrimeExplore from '../SsDesktopMenuPrimeExplore/index.vue'
import SsUserPrimeCard from '../../../SsUserPrimeCard'
import SsCoCreationItemCard from '../../../SsCoCreationItemCard/index.vue'
import SsCoCreationEntryCard from '../../../SsCoCreationEntryCard/index.vue'

export default {
  name: 'SsDesktopSubmenuItem',

  components: {
    SsDesktopMenuItem,
    SsDesktopMenuPostItem,
    SsDesktopMenuSeriesItem,
    SsDesktopMenuGoodItem,
    SsDesktopMenuPrimeExplore,
    SsUserPrimeCard,
    SsCoCreationItemCard,
    SsCoCreationEntryCard
  },

  props: {
    submenu: {
      type: Object
    }
  }
}
</script>

<style lang="stylus" scoped>
.ss__desktop__submenu__item {
  flex-shrink: 0;
  padding: var(--padding-SsDesktopSubmenuItem, 0);
  border-bottom: var(--border-b-SsDesktopSubmenuItem, none);
  width: var(--w-SsDesktopSubmenuItem, 200px);
  >>> a {
    cursor: pointer;
    color: inherit;
  }
}
.ss__desktop__submenu__item--normal {
  width: var(--w-SsDesktopSubmenuItem, 200px);
}
.ss__desktop__submenu__item--card {
  width: var(--w-SsDesktopSubmenuItem, 588px);
}

.ss__desktop__submenu__item__head {
  display: var(--display-SsDesktopSubmenuItemHead, flex);
  flex-direction: var(--direction-SsDesktopSubmenuItemHead, column)
  column-gap: var(--gap-SsDesktopSubmenuItemHead, 4px);
  row-gap: var(--gap-SsDesktopSubmenuItemHead, 4px);
  align-items: var(--align-SsDesktopSubmenuItemHead, flex-start);
}

.ss__desktop__submenu__item__image {
  width: var(--w-SsDesktopSubmenuItemImage, 70px);
  height: var(--h-SsDesktopSubmenuItemImage, 32px);
  object-fit: contain;
}

.ss__desktop__submenu__item__name {
  font-size: var(--text-SsDesktopSubmenuItemName, 22px);
  font-weight: var(--weight-SsDesktopSubmenuItemName, 500);
  font-family: var(--font-SsDesktopSubmenuItemName, inherit);
  color: var(--color-SsDesktopSubmenuItemName, var(--B8-t));
  margin: var(--margin-SsDesktopSubmenuItemName, (0 0 24px));
  white-space: pre-wrap;
}

.ss__desktop__submenu__item__children {
  .comp__SsDesktopMenuItem {
    box-sizing: border-box;
    --w-SsDesktopMenuItemContent: var(--w-SsDesktopSubmenuItemChild, 100%);
    --h-SsDesktopMenuItemContent: var(--h-SsDesktopSubmenuItemChild, 56px);
    --gap-SsDesktopMenuItemInner: var(--gap-SsDesktopSubmenuItemChild, 8px);
    --size-SsDesktopMenuItemIcon: var(--size-SsDesktopSubmenuItemChildIcon, 32px);
    --padding-SsDesktopMenuItemIcon: var(--padding-SsDesktopSubmenuItemChildIcon, 0px)
    --font-SsDesktopMenuItemName: var(--font-SsDesktopSubmenuItemChildName, inherit);
    --text-SsDesktopMenuItemName: var(--text-SsDesktopSubmenuItemChildName, 17px);
    --weight-SsDesktopMenuItemName: var(--weight-SsDesktopSubmenuItemChildName, 500);
    & + .comp__SsDesktopMenuItem {
      border-top: var(--border-SsDesktopMenuItemContent, none);
    }
  }
}

.ss__desktop__submenu__item__children--card {
  display: var(--display-SsDesktopSubmenuItemChildren, flex);
  flex-direction: var(--direction-SsDesktopSubmenuItemChildren, row);
  flex-wrap: var(--wrap-SsDesktopSubmenuItemChildren, wrap);
  column-gap: var(--gap-SsDesktopSubmenuItemChildren, 24px);
  row-gap: var(--gap-SsDesktopSubmenuItemChildren, 24px);
}

.ss__desktop__submenu__item__children--normal {
  display: var(--display-SsDesktopSubmenuItemChildren, block);
  flex-direction: var(--direction-SsDesktopSubmenuItemChildren, row);
  flex-wrap: var(--wrap-SsDesktopSubmenuItemChildren, wrap);
  column-gap: var(--gap-SsDesktopSubmenuItemChildren, 0px);
  row-gap: var(--gap-SsDesktopSubmenuItemChildren, 0px);
}

.comp__SsUserPrimeCard {
  width: 140px;
  height: 202px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto;
  >>> .ss__user__prime__card__perspective {
    flex-shrink: 0;
    transform: scale(0.42) rotate3d(0, 0, 1, 4deg);
  }
}
</style>
